export const columnsData = [
  {
    Header: "DATE",
    accessor: "reservationDate",
  },
  {
    Header: "BLOCK TYPE",
    accessor: "blockType",
  },
  {
    Header: "TIME WINDOW",
    accessor: "startTime",
  },
  {
    Header: "REASON",
    accessor: "reason",
  },
];
